import { render, staticRenderFns } from "./CreateBulkModal.vue?vue&type=template&id=94e5b1cc&scoped=true&"
import script from "./CreateBulkModal.vue?vue&type=script&lang=ts&"
export * from "./CreateBulkModal.vue?vue&type=script&lang=ts&"
import style0 from "./CreateBulkModal.vue?vue&type=style&index=0&id=94e5b1cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94e5b1cc",
  null
  
)

export default component.exports